const AnimatedShape = (function () {
    const TAN = Math.tan(35 * Math.PI / 180);

    function updateClipPath(hero: HTMLElement) {
        const heroHeight = hero.offsetHeight;
        const setAngle = heroHeight * TAN;
        hero.style.setProperty('--setAngle', `${setAngle}px`)
    }

    function init(): void {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        document.addEventListener("DOMContentLoaded", () => {
            const largeShape = document.querySelector('.hero-block__large-shape') as HTMLElement | null;
            if (!largeShape) return;
            updateClipPath(largeShape)

            requestAnimationFrame(() => {
                largeShape.classList.add("is-ready")
            })
            largeShape.addEventListener('animationend', () => {
                updateClipPath(largeShape)
            })
            window.addEventListener('resize', () => {
                updateClipPath(largeShape)
            })
        })
    }
    return {
        init,
    }
})();

export default AnimatedShape;